import { useEffect } from "react";
import { Button, Form, Modal, notification } from "antd";

import { POST } from "../../../../providers/useAxiosQuery";
import notificationErrors from "../../../../providers/notificationErrors";
import FloatSelect from "../../../../providers/FloatSelect";
import validateRules from "../../../../providers/validateRules";
import FloatInput from "../../../../providers/FloatInput";

export default function ModalFormStudentSchedule(props) {
	const {
		toggleModalStudentSchedule,
		setToggleModalStudentSchedule,
		dataProfile,
		dataSubject,
		dataSection,
		dataSemester,
		dataSchoolYear,
		dataCourse,
	} = props;

	const [form] = Form.useForm();

	const { mutate: mutateStudentSchedule, isLoading: isLoadingStudentSchedule } =
		POST("api/student_schedules", "student_schedule_list");

	const onFinish = (values) => {
		let data = {
			...values,
			id: toggleModalStudentSchedule.data?.id || null,
		};

		mutateStudentSchedule(data, {
			onSuccess: (res) => {
				if (res.success) {
					notification.success({
						message: "Student Schedule Import",
						description: res.message,
					});
					setToggleModalStudentSchedule({
						open: false,
						data: null,
					});
					form.resetFields();
				} else {
					notification.error({
						message: "Student Schedule Import",
						description: res.message,
					});
				}
			},
			onError: (err) => {
				notificationErrors(err);
			},
		});
	};

	useEffect(() => {
		if (toggleModalStudentSchedule.open) {
			form.setFieldsValue({
				stud_profile_id:
					toggleModalStudentSchedule.data?.stud_profile_id || null,
				school_year_id: toggleModalStudentSchedule.data?.school_year_id || null,
				subject_id: toggleModalStudentSchedule.data?.subject_id || null,
				section_id: toggleModalStudentSchedule.data?.section_id || null,
				semester_id: toggleModalStudentSchedule.data?.semester_id || null,
				course_id: toggleModalStudentSchedule.data?.course_id || null,
				credit_unit: toggleModalStudentSchedule.data?.credit_unit || null,
			});
		}

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [toggleModalStudentSchedule]);

	return (
		<Modal
			title="Student Schedule Import"
			open={toggleModalStudentSchedule.open}
			wrapClassName="modal-wrap-data-import-excel"
			onCancel={() => {
				setToggleModalStudentSchedule({
					open: false,
					data: null,
				});
				form.resetFields();
			}}
			footer={[
				<Button
					className="btn-main-primary outlined"
					key={1}
					onClick={() => {
						setToggleModalStudentSchedule({
							open: false,
							data: null,
						});
						form.resetFields();
					}}
					disabled={isLoadingStudentSchedule}
				>
					Cancel
				</Button>,
				<Button
					className="btn-main-primary"
					type="primary"
					key={2}
					loading={isLoadingStudentSchedule}
					onClick={() => {
						form.submit();
					}}
				>
					Submit
				</Button>,
			]}
			forceRender
		>
			<Form form={form} onFinish={onFinish}>
				<Form.Item name="stud_profile_id" rules={[validateRules.required()]}>
					<FloatSelect
						label="Student"
						placeholder="Student"
						required
						options={
							dataProfile
								? dataProfile.data.map((item) => ({
										value: item.id,
										label: `${item.school_id} - ${item.fullname}`,
									}))
								: []
						}
					/>
				</Form.Item>

				<Form.Item name="subject_id" rules={[validateRules.required()]}>
					<FloatSelect
						label="Subject"
						placeholder="Subject"
						required
						options={
							dataSubject
								? dataSubject.data.map((item) => ({
										value: item.id,
										label: `${item.code} - ${item.description}`,
									}))
								: []
						}
					/>
				</Form.Item>

				<Form.Item name="section_id" rules={[validateRules.required()]}>
					<FloatSelect
						label="Section"
						placeholder="Section"
						required
						options={
							dataSection
								? dataSection.data.map((item) => ({
										value: item.id,
										label: `${item.section}`,
									}))
								: []
						}
					/>
				</Form.Item>

				<Form.Item name="semester_id" rules={[validateRules.required()]}>
					<FloatSelect
						label="Semester"
						placeholder="Semester"
						required
						options={
							dataSemester
								? dataSemester.data.map((item) => ({
										value: item.id,
										label: `${item.semester}`,
									}))
								: []
						}
					/>
				</Form.Item>

				<Form.Item name="school_year_id" rules={[validateRules.required()]}>
					<FloatSelect
						label="School Year"
						placeholder="School Year"
						required
						options={
							dataSchoolYear
								? dataSchoolYear.data.map((item) => ({
										value: item.id,
										label: `${item.school_year}`,
									}))
								: []
						}
					/>
				</Form.Item>

				<Form.Item name="course_id" rules={[validateRules.required()]}>
					<FloatSelect
						label="Course"
						placeholder="Course"
						required
						options={
							dataCourse
								? dataCourse.data.map((item) => ({
										value: item.id,
										label: `${item.course_name}`,
									}))
								: []
						}
					/>
				</Form.Item>

				<Form.Item name="credit_unit" rules={[validateRules.required()]}>
					<FloatInput label="Credit Unit" placeholder="Credit Unit" required />
				</Form.Item>
			</Form>
		</Modal>
	);
}
